<script lang="ts">
    import {FieldErrorPopover} from 'src/features/record/field-error';
    import type {ErrorGridFieldValue} from 'src/features/record-grid/lib/types';

    export let value: ErrorGridFieldValue;
</script>

<FieldErrorPopover error={value.error}/>

<span>{value.text}</span>